import { ReactElement } from 'react';
import DashboardWrapper from './DashboardWrapper';
import Users from '../screens/protected/Users';
import ChangePassword from '../screens/protected/ChangePassword';
import Tickets from '../screens/protected/Tickets';
import Category from '../screens/protected/Category';




import Permission from '../screens/protected/Setting/Permission';
import Login from '../screens/public/Login';
import NotFound from '../screens/NotFound';
import FaceCapture from '../components/FaceCapture';
import RegisterFace from '../components/RegisterFace';
import Organization from '../screens/protected/organization-master/index';
import Modules from '../screens/protected/module/index';
import SubscriptionMaster from '../screens/protected/subscription-master/index';
import Profile from '../screens/protected/profile/index';
import Setting from '../screens/protected/Setting/Setting/index';
import PaymentSettings from '../screens/protected/Setting/PaymentSettings/index';
import SmsSettings from '../screens/protected/Setting/SmsSettings/index';
import WhatsappSettings from '../screens/protected/Setting/WhatsappSettings/index';
import EmailSettings from '../screens/protected/Setting/EmailSettings/index';


import InventoryManagements from '../screens/protected/handicraft/inventory-managements/index';

import MedicalProducts from '../screens/protected/products/medical-products';
import SaleTypes from '../screens/protected/masters/sale-types/index'
import Caring from '../screens/protected/masters/caring/index'
import LeadMaster from '../screens/protected/front-desk/student-leads/index'
import GatePass from '../screens/protected/front-desk/gate-pass/index'
import GeneralEnquiry from '../screens/protected/front-desk/general-enquiry/index'
import Holidays from '../screens/protected/masters/holiday/index';
import Attendance from '../screens/protected/attendance/index';


import Template from '../screens/protected/masters/template-master/index'
import BrandNames from '../screens/protected/masters/brand-names/index';


import Size from '../screens/protected/masters/sizes/index';
import BookNumbers from '../screens/protected/masters/booknumber';
import CardNumbers from '../screens/protected/masters/cardnumber';
import RackNumbers from '../screens/protected/masters/racknumber';
import BlockNumbers from '../screens/protected/masters/blocknumber';
import Places from '../screens/protected/masters/places';


import Pages from '../screens/protected/WebMaster/Pages/index'

import Vouchers from '../screens/protected/voucher';
import POS from '../screens/protected/Billing/pos';
import Billing from '../screens/protected/Billing';


import Client from '../screens/protected/client'
import Width from '../screens/protected/masters/widths'
import HSNCode from '../screens/protected/masters/hsn-codes'
import Composition from '../screens/protected/masters/compositions'
import UnitTypes from '../screens/protected/masters/unit-types'
import GST from '../screens/protected/masters/gst'

// accounts 
import AccountHeads from '../screens/protected/accounts/account-heads'
import ReviewMaster from '../screens/protected/accounts/review-master'
import Legders from '../screens/protected/accounts/ledger'
import SviconLegders from '../screens/protected/accounts/ledger/svicon-index'

import QuickRegistration from '../screens/public/QuickRegistration';


import Blogs from '../screens/protected/WebMaster/Blogs';
import Guideline from '../screens/protected/WebMaster/Guideline';
import Payrolls from '../screens/protected/accounts/payrolls';


import EmployeeAttendance from '../screens/protected/EmployeeAttendance';
import LeaveRequest from '../screens/protected/Users/LeaveRequest';
import Wallet from '../screens/protected/accounts/wallet/index';

import BodyPart from '../screens/protected/masters/bodyparts/index';
import BodyPartType from '../screens/protected/masters/bodyparts/body-part-type';
import Designations from '../screens/protected/ledger-mastes/designations';
import Occupations from '../screens/protected/ledger-mastes/occupations';
import Festivals from '../screens/protected/ledger-mastes/festivals';
import GstTypes from '../screens/protected/ledger-mastes/gst-types';
import Reminder from '../screens/protected/masters/reminders/index';

import Countries from '../screens/protected/masters/location-masters/countries';
import States from '../screens/protected/masters/location-masters/states';
import Cities from '../screens/protected/masters/location-masters/cities';


import Department from '../screens/protected/masters/departments';
import Employee from '../screens/protected/Users/employees';
import PI from '../screens/protected/sales/pi';

import Services from '../screens/protected/it/Services/index';
import ClientServices from '../screens/protected/it/ClientService/ClientServices';
import Projects from '../screens/protected/it/Projects/index';
import CompanySettings from '../screens/protected/company-detailes';
import Expenses from '../screens/protected/Expenses';
import Coupons from '../screens/protected/coupons/index';
// Define route shape
interface AppRoute {
  path: string;
  element: ReactElement;
  protected: boolean;
}

export const routes: AppRoute[] = [
  {
    path: '/',
    element: <DashboardWrapper />,
    protected: true,
  },
  {
    path: '/users',
    element: <Users />,
    protected: true,
  },
  {
    path: '/tickets',
    element: <Tickets />,
    protected: true,
  },
  {
    path: '/category',
    element: <Category />,
    protected: true,
  },
  {
    path: '/permissions',
    element: <Permission />,
    protected: true,
  },
  {
    path: '/login',
    element: <Login />,
    protected: false,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
    protected: true,
  },
  {
    path: '/face',
    element: <FaceCapture />,
    protected: false,
  },
  {
    path: '/register-face',
    element: <RegisterFace />,
    protected: false,
  },
  {
    path: '/organization',
    element: <Organization />,
    protected: true,
  },
  {
    path: '/modules',
    element: <Modules />,
    protected: true,
  },
  {
    path: '/subscription',
    element: <SubscriptionMaster />,
    protected: true,
  },
  {
    path: '/profile',
    element: <Profile />,
    protected: true,
  },
  {
    path: '/setting',
    element: <Setting />,
    protected: true,
  },
  {
    path: '/payment-setting',
    element: <PaymentSettings />,
    protected: true,
  },
  {
    path: '/sms-setting',
    element: <SmsSettings />,
    protected: true,
  },
  {
    path: '/whatsapp-setting',
    element: <WhatsappSettings />,
    protected: true,
  },
  {
    path: '/email-setting',
    element: <EmailSettings />,
    protected: true,
  },
  {
    path: '/medical-products',
    element: <MedicalProducts />,
    protected: true,
  },
  {
    path: '/inventory-managements',
    element: <InventoryManagements />,
    protected: true,
  },
  {
    path: '/templates',
    element: <Template />,
    protected: true,
  },
  {
    path: '/brand-names',
    element: <BrandNames />,
    protected: true,
  },
  {
    path: '/designations',
    element: <Designations />,
    protected: true,
  },
  {
    path: '/countries',
    element: <Countries />,
    protected: true,
  },
  {
    path: '/states',
    element: <States />,
    protected: true,
  },
  {
    path: '/cities',
    element: <Cities />,
    protected: true,
  },
  {
    path: '/occupations',
    element: <Occupations />,
    protected: true,
  },
  {
    path: '/festivals',
    element: <Festivals />,
    protected: true,
  },
  {
    path: '/gst-types',
    element: <GstTypes />,
    protected: true,
  },
  {
    path: '/carings',
    element: <Caring />,
    protected: true,
  },
  {
    path: '/sizes',
    element: <Size />,
    protected: true,
  },
  {
    path: '/sale-types',
    element: <SaleTypes />,
    protected: true,
  },
  {
    path: '/holidays',
    element: <Holidays />,
    protected: true,
  },
  {
    path: '/book-number',
    element: <BookNumbers />,
    protected: true,
  },
  {
    path: '/card-number',
    element: <CardNumbers />,
    protected: true,
  },
  {
    path: '/rack-number',
    element: <RackNumbers />,
    protected: true,
  },
  {
    path: '/block-number',
    element: <BlockNumbers />,
    protected: true,
  },
  {
    path: '/places',
    element: <Places />,
    protected: true,
  },
  {
    path: '/attendance',
    element: <Attendance />,
    protected: true,
  },
  {
    path: '/leads',
    element: <LeadMaster />,
    protected: true,
  },
  {
    path: '/general-enquiry',
    element: <GeneralEnquiry />,
    protected: true,
  },
  {
    path: '/gate-pass',
    element: <GatePass />,
    protected: true,
  },
  {
    path: '/pages',
    element: <Pages />,
    protected: true,
  },
  {
    path: '/vouchers',
    element: <Vouchers />,
    protected: true,
  },
  {
    path: '/pos',
    element: <POS />,
    protected: true,
  },
  {
    path: '/pos/:sale_id?',
    element: <POS />,
    protected: true,
  },
  {
    path: '/billing',
    element: <Billing />,
    protected: true,
  },
  {
    path: '/clients',
    element: <Client />,
    protected: true,
  },
  {
    path: '/widths',
    element: <Width />,
    protected: true,
  },
  {
    path: '/hsn-codes',
    element: <HSNCode />,
    protected: true,
  },
  {
    path: '/compositions',
    element: <Composition />,
    protected: true,
  },
  {
    path: '/unit-types',
    element: <UnitTypes />,
    protected: true,
  },
  {
    path: '/gsts',
    element: <GST />,
    protected: true,
  },
  // account 
  {
    path: '/account-heads',
    element: <AccountHeads />,
    protected: true,
  },
  {
    path: '/review-master',
    element: <ReviewMaster />,
    protected: true,
  },
  {
    path: '/ledgers',
    element: <Legders />,
    protected: true,
  },
  {
    path: '/h-ledgers',
    element: <SviconLegders />,
    protected: true,
  },
  {
    path: '/quick-registration',
    element: <QuickRegistration />,
    protected: false,
  },
  {
    path: '/blogs',
    element: <Blogs />,
    protected: true,
  },
  {
    path: '/guidelines',
    element: <Guideline />,
    protected: true,
  },
  {
    path: '/payrolls',
    element: <Payrolls />,
    protected: true,
  },
  {
    path: '/attendances',
    element: <EmployeeAttendance />,
    protected: true,
  },
  {
    path: '/leave-requests',
    element: <LeaveRequest />,
    protected: true,
  },
  {
    path: '/wallets',
    element: <Wallet />,
    protected: true,
  },
  {
    path: '/body-parts',
    element: <BodyPart />,
    protected: true,
  },
  {
    path: '/body-part-type',
    element: <BodyPartType />,
    protected: true,
  },
  {
    path: '/reminders',
    element: <Reminder />,
    protected: true,
  },
  {
    path: '/departments',
    element: <Department />,
    protected: true,
  },
  {
    path: '/employees',
    element: <Employee />,
    protected: true,
  },
  {
    path: '/pi',
    element: <PI />,
    protected: true,
  },
  {
    path: '/services',
    element: <Services />,
    protected: true,
  },
  {
    path: '/client-services',
    element: <ClientServices />,
    protected: true,
  },
  {
    path: '/projects',
    element: <Projects />,
    protected: true,
  },
  {
    path: '/company-setting',
    element: <CompanySettings />,
    protected: true,
  },
  {
    path: '/expenses',
    element: <Expenses />,
    protected: true,
  },
  {
    path: '/coupons',
    element: <Coupons />,
    protected: true,
  },
  {
    path: '*',
    element: <NotFound />,
    protected: false,
  },
];
